export class ListSparkJobsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListSparkJobsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSparkJobBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSparkJobsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
